import React from "react";
import styles from "./style.module.css";

interface Props {
  text: string;
}

export default function Alert({ text }: Props) {
  const lineBreak = (value?: string) =>
    value
      ? value.split("\\n").map((v, i) => (i ? [<br key={i} />, v] : v))
      : "";
  return (
    <div className={styles.alertWrap}>
      <span className={styles.alert}>{lineBreak(text)}</span>
    </div>
  );
}
